import api from "src/apis/api"

// Standalone tasks
export async function fetchTasks(params = {}) {
  const { data } = await api.get("/api/v1/tasks", { params })
  return data.tasks || []
}

export async function fetchMyDay() {
  const { data } = await api.get("/api/v1/tasks/my_day")
  return data
}

export async function fetchTask(id) {
  const { data } = await api.get(`/api/v1/tasks/${id}`)
  return data.task
}

// Tasks nested under a parent (lead / deal / booking)
export async function fetchTasksForParent(parentType, parentId) {
  const { data } = await api.get(`/api/v1/${parentType}/${parentId}/tasks`)
  return data.tasks || []
}

export async function createTask(task, parent = null) {
  const url = parent
    ? `/api/v1/${parent.type}/${parent.id}/tasks`
    : "/api/v1/tasks"
  const { data } = await api.post(url, { task })
  return data.task
}

export async function updateTask(id, task) {
  const { data } = await api.patch(`/api/v1/tasks/${id}`, { task })
  return data.task
}

export async function deleteTask(id) {
  const { data } = await api.delete(`/api/v1/tasks/${id}`)
  return data
}

export async function completeTask(id) {
  const { data } = await api.post(`/api/v1/tasks/${id}/complete`)
  return data.task
}

export async function reopenTask(id) {
  const { data } = await api.post(`/api/v1/tasks/${id}/reopen`)
  return data.task
}

export async function snoozeTask(id, until) {
  const { data } = await api.post(`/api/v1/tasks/${id}/snooze`, { until })
  return data.task
}

export async function unsnoozeTask(id) {
  const { data } = await api.post(`/api/v1/tasks/${id}/unsnooze`)
  return data.task
}
